import { Col, Row } from 'reactstrap';

const SummaryWidgetsSkeleton = () => (
    <Row className="g-3">
        {[1, 2, 3, 4, 5, 6].map((item) => (
            <Col key={item} xs="12" sm="6" md="4" xl="2">
                <div className="dt-field dt-skeleton" style={{ width: '100%', height: '112px' }} />
            </Col>
        ))}
    </Row>
);

export default SummaryWidgetsSkeleton;
